export default __webpack_public_path__ + "static/media/mastercard.cb0be0f6.svg";